import {isEmptyValue, createTooltipFields} from "./TooltipUtil";
/**
 * Generate tooltip HTML with two-column layout
 *
 * @param {string} title - Tooltip title
 * @param {Object} data - The data object containing the values
 * @param {Array} fieldConfig - Array of field configurations
 * @param {Object} tooltipConfig - Tooltip configuration options
 * @returns {string} HTML string for tooltip
 *
 * @example
 * const data = { id: 1, name: "Example", area: 123.45 };
 * const fieldConfig = [
 *   { key: "id", label: "ID" },
 *   { key: "name", label: "Name" },
 *   { key: "area", label: "Area", format: value => formatNumber(value, "km²") }
 * ];
 *
 * const html = generateTooltipHTML("My Layer", data, fieldConfig, {
 *   width: "500px",
 *   height: "400px",
 *   wrapValues: true,
 *   naValue: "—"
 * });
 */
export const generatePopupHTML = (title, data, fieldConfig, tooltipConfig = {}) => {
    const {
        labelWidth = "36%",
        valueWidth = "60%",
        wrapValues = true,
        naValue = "N/A",
    } = tooltipConfig;

    const fields = createTooltipFields(data, fieldConfig);

    let html = `
        <div class="custom-popup">
            <div class="custom-popup-title">${title}</div>
            <div class="custom-popup-content">
    `;

    fields.forEach(field => {
        const labelStyle = `
            font-weight: bold;
            color: #555;
            white-space: nowrap;
            min-width: ${labelWidth};
            display: inline-block;
        `;

        const valueStyle = `
            color: #333;
            ${wrapValues ? "word-wrap: break-word; white-space: normal;" : "white-space: nowrap;"}
            min-width: ${valueWidth};
            display: inline-block;
        `;

        let displayValue = field.value;

        // Apply formatting if specified
        if (field.format && typeof field.format === "function") {
            displayValue = field.format(field.value);
        }

        // Handle null/empty values centrally
        if (isEmptyValue(displayValue)) {
            displayValue = naValue;
        }

        html += `
            <div class="tooltip-row" style="display: flex; gap: 8px; align-items: flex-start;">
                <div class="tooltip-label" style="${labelStyle}">${field.label}:</div>
                <div class="tooltip-value" style="${valueStyle}">${displayValue}</div>
            </div>
        `;
    });

    html += `
            </div>
        </div>
    `;

    return html;
};
